export var POWER_GAP = 5;
export var MIN_POWER_VALUE = 50;
export var MAX_POWER_VALUE = 745;
export function getPowersToFilter(minPower, maxPower) {
    if (minPower > maxPower)
        return [];
    var result = [];
    for (var i = minPower; i <= maxPower; i += 5) {
        result.push(i.toString());
    }
    return result;
}
